import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pole-training',
  templateUrl: './pole-training.component.html',
  styleUrls: ['./pole-training.component.scss']
})
export class PoleTrainingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
